import { Reveal } from "../components/Reveal";
import { usePageMeta } from "../lib/api";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you contact Show Me Shield through this website, we collect the information you choose to share: your name, phone number, email address, ZIP code, the coverage topics you're interested in, and anything you write to us. We collect only what's needed to respond to you.",
  },
  {
    title: "How we use it",
    body: "We use your information to follow up on your request, answer your questions, and — only if you've opted in — send occasional helpful insurance information. We do not sell your personal information.",
  },
  {
    title: "What we don't do",
    body: "We never ask for detailed medical information through website forms, and we never send sensitive health information by ordinary email. Marketing checkboxes are never pre-checked; consent is always your choice.",
  },
  {
    title: "Security",
    body: "This site uses HTTPS encryption, server-side validation, rate limiting, and spam protection. Lead information is stored securely and access is limited to the people responding to you.",
  },
  {
    title: "Your choices",
    body: "You can ask us to update or delete your contact information at any time by emailing showmeshield@gmail.com or calling (417) 413-2882.",
  },
];

const Privacy = () => {
  usePageMeta("Privacy Policy | Show Me Shield", "How Show Me Shield Benefits LLC collects, uses, and protects your information.", { path: "/privacy" });

  return (
    <main className="bg-paper">
      <div className="border-b border-ink/10 bg-ink">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <Reveal>
            <p className="eyebrow mb-3">Legal</p>
            <h1 className="h-display text-4xl text-white sm:text-5xl">Privacy Policy</h1>
          </Reveal>
        </div>
      </div>
      <div className="mx-auto max-w-4xl space-y-10 px-4 py-16 sm:px-6">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-ink">{s.title}</h2>
            <p className="mt-3 text-base leading-relaxed text-primer">{s.body}</p>
          </Reveal>
        ))}
        <p className="text-xs text-zinc-500">
          Show Me Shield Benefits LLC &bull; ShowMeShield.com &bull; Last updated {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}
        </p>
      </div>
    </main>
  );
};

export default Privacy;
